<template>
  <section class="title-sec ">
    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <h1>Billing</h1>
          <p>Manage your payment methods and view your billing details here.</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 billing-tab">
          <a href="/billing-details" :class="currentPath == '/billing-details' ? 'tab-active' : '' ">Membership</a>
          <a href="/billing-impacts" :class="currentPath == '/billing-impacts' ? 'tab-active' : '' ">Impact</a>
          <a href="/billing-tokens" :class="currentPath == '/billing-tokens' ? 'tab-active' : '' " v-if="company.token_management_access === '1'" >Tokens</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import store from '../../../store'
export default {
  name: 'BillingTabs',
  data () {
    return {
      currentPath: '/billing-details',
      company: store.getters.currentUser.companydata
    }
  },
  created () {
    this.currentPath = this.$route.path
  }
}
</script>
<style scoped>
.billing-tab a {
    width: 240px;
    height: 90px;
    display: inline-block;
    border: 1px solid #ddd;
    text-align: center;
    line-height: 86px;
    font-size: 22px;
    text-transform: uppercase;
    background: #f7f7f7;
    color: #000;
    font-weight: 500;
    font-family: "Brandon Grotesque";
}
.tab-active {
    background: #47BFEE !important;
    color: #fff !important;
    border-color: #47BFEE !important;
}
</style>



// WEBPACK FOOTER //
// src/components/business/Billing/tabs.vue